import { GeolocalizationProvider } from "./../geolocalization/geolocalization";
import { Injectable, Output, EventEmitter, ElementRef } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { v4 as uuid } from "uuid";
import * as _ from "lodash";
declare var google: any;
/*
  Generated class for the GmapsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GmapsProvider {
    filter = null;
    map: any;
    latlng: any;
    placeServices: any;
    markers: any[] = [];
    visibleMarkers: any[] = [];
    currentPosition = null;
    @Output() markerSelected = new EventEmitter();
    @Output() mapClicked = new EventEmitter();

    constructor(public geolocalizationProvider: GeolocalizationProvider,
        public translateService: TranslateService) {
        this.geolocalizationProvider.currentPosition.subscribe(data => {
            this.currentPosition = data;
        });
    }

    async getPlace(markerSelected) {

        return new Promise((resolve, reject) => {
            let place: any = null;
            let geocoder = new google.maps.Geocoder;
            let latlng = { lat: parseFloat(markerSelected.lat), lng: parseFloat(markerSelected.lng) };
            geocoder.geocode({ 'location': latlng }, function (results, status) {
                if (status === 'OK') {
                    if (results[0]) {
                        place = {
                            id: "newMarker",
                            name: "",
                            address: results[0].formatted_address,
                            location: latlng,
                            origin: "google",
                        };
                        resolve(place);
                    } else {
                        reject(new Error('No results found'));
                    }
                } else {
                    reject(new Error('Geocoder failed due to: ' + status));
                }
            });
        });
    }

    //'M' is statute miles
    //'K' is kilometers (default)
    //'N' is nautical miles
    distanceBetween(lat1, lon1, lat2, lon2, unit = 'K') {
        if ((lat1 == lat2) && (lon1 == lon2)) {
            return 0;
        }
        else {
            var radlat1 = Math.PI * lat1 / 180;
            var radlat2 = Math.PI * lat2 / 180;
            var theta = lon1 - lon2;
            var radtheta = Math.PI * theta / 180;
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = dist * 180 / Math.PI;
            dist = dist * 60 * 1.1515;
            if (unit == "K") { dist = dist * 1.609344 }
            if (unit == "N") { dist = dist * 0.8684 }
            return dist;
        }
    }

    getRadiusFromZoom() {
        if (!this.map)
            return 0;

        let visibleRegion = this.map.getBounds();
        let dist = 0;

        if (visibleRegion) {
            let distance = this.distanceBetween(
                visibleRegion.getNorthEast().lat(),
                visibleRegion.getNorthEast().lng(),
                visibleRegion.getSouthWest().lat(),
                visibleRegion.getSouthWest().lng(),
                'K'
            ) * 1000; //convert Km to meters

            //radius in meters
            dist = distance / 2;
        }

        return dist ? dist : 1000;
    }

    async findPlacesAt(location) {
        let request = {
            location: location,
            radius: this.getRadiusFromZoom(),
            fields: ['photos', 'address_component']
        };

        //debug search radius
        /**************************
        
        new google.maps.Circle({
            strokeColor: '#FF0000',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#FF0000',
            fillOpacity: 0.35,
            map: this.map,
            center: location,
            radius: request.radius
        });
        
        **************************/

        this.doSearchPlaces(request).then((results: any[]) => {
            results.forEach(data => {
                let tmpSpots = this.visibleMarkers.concat(this.markers);

                // filter marks on same position
                let foundItemIndex = _.findIndex(tmpSpots, item => {
                    return (
                        item.marker.position.lat() == data.location.lat &&
                        item.marker.position.lng() == data.location.lng
                    );
                });
                if (foundItemIndex === -1) {
                    this.createMarker(data);
                }
            });
        });
    }

    async findPlaces() {
        if (this.currentPosition) {
            //console.log("places updated");
            this.findPlacesAt(this.currentPosition);
            this.createCurrentPositionMarker();
        }
        else {
            //console.log("current position is null");
        }
    }

    createCurrentPositionMarker() {
        let marker = new google.maps.Marker({
            position: new google.maps.LatLng(this.currentPosition.lat, this.currentPosition.lng),
            icon: 'assets/imgs/marker-current-position.svg',
        });

        this.addMarkerVisible({ meta: { id: 'currentPosition' }, marker: marker });
    }

    async searchPlaces(keywords: string) {
        return new Promise<any[]>(async (resolve, reject) => {
            let mapCenter = this.map.getCenter();
            if (mapCenter) {
                //console.log("Searching places...");

                let request = {
                    keyword: keywords,
                    location: mapCenter,
                    radius: this.getRadiusFromZoom(),
                    fields: ['photos', 'address_component']
                };

                this.doSearchPlaces(request)
                    .then((results: any[]) => {
                        resolve(results);
                    })
                    .catch((e) => reject(e));
            }
            else {
                reject(new Error("Current position is null"));
            }
        });
    }

    doSearchPlaces(request: any) {

        return new Promise((resolve) => {
            var finalResults: any[] = [];

            this.placeServices.nearbySearch(request, (results, status) => {
                if (status == google.maps.places.PlacesServiceStatus.OK) {

                    for (let i = 0; i < results.length; i++) {
                        let place = results[i];

                        let data = {
                            id: uuid(),
                            icon: place.icon,
                            name: place.name,
                            address: place.vicinity,
                            origin: "google",
                            location: {
                                lat: place.geometry.location.lat(),
                                lng: place.geometry.location.lng()
                            }
                        };

                        finalResults.push(data);
                    }
                }

                resolve(finalResults);
            });
        });
    }

    executeFilter(item) {
        if (!this.filter || !this.filter.data) {
            return true;
        }

        if (this.filter.exactly) {
            if (
                item.meta && this.filter.data.toString().toUpperCase() === item.meta[this.filter.field].toString().toUpperCase()
            ) {
                return true;
            }
        } else {
            let input = this.filter.data
                .toString()
                .replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"); // scape regex
            let regexPattern = new RegExp(input, "i");
            if (
                item.meta && item.meta[this.filter.field] && item.meta[this.filter.field].toString().search(regexPattern) > -1
            ) {
                return true;
            }
        }

        return false;
    }

    filterBy(data, field, exactly = false) {
        this.filter = { data: data, field: field, exactly: exactly };

        let tmpRemovedItens = _.remove(this.visibleMarkers, item => {
            return !this.executeFilter(item);
        });

        this.markers.slice().map(item => {
            if (this.executeFilter(item)) {
                this.addMarkerVisible(item);
            }
        });

        tmpRemovedItens.map(item => {
            this.removeMarkerVisible(item);
        });
    }

    async createMap(elementRef: ElementRef, initialPosition = null) {
        return new Promise((resolve, reject) => {
            let element = elementRef.nativeElement;
            this.latlng = initialPosition ? initialPosition : this.currentPosition;
            let onMapScriptLoaded = () => {

                let mapOptions = {
                    center: this.latlng,
                    zoom: 18,
                    minZoom: 16,
                    maxZoom:20,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    styles: [
                        {
                            featureType: "poi",
                            elementType: "labels",
                            stylers: [{ visibility: "off" }]
                        }
                    ],
                    disableDefaultUI: true,
                    gestureHandling: "greedy" //disable two finger scroll
                };

                this.map = new google.maps.Map(element, mapOptions);
                this.placeServices = new google.maps.places.PlacesService(this.map);

                this.map.addListener("click", event => {
                    this.mapClicked.emit(event);
                });

                resolve();
            };

            //load or wait for google maps script
            if (window['google'] && window['google']['maps']) {
                onMapScriptLoaded();
            }
            else {
                window.addEventListener('load', onMapScriptLoaded);
            }

            /*
            google.maps.event.addListener(this.map, "zoom_changed", () => {
                var pixelSizeAtZoom0 = 12; //the size of the icon at zoom level 0
                var maxPixelSize = 54; //restricts the maximum size of the icon, otherwise the browser will choke at higher zoom levels trying to scale an image to millions of pixels
                var zoom = this.map.getZoom();
                var relativePixelSize = Math.round(pixelSizeAtZoom0 * Math.pow(2, zoom)); // use 2 to the power of current zoom to calculate relative pixel size.  Base of exponent is 2 because relative size should double every time you zoom in
                if (relativePixelSize > maxPixelSize)
                    //restrict the maximum size of the icon
                    relativePixelSize = maxPixelSize;
                //change the size of the icon
                this.visibleMarkers.forEach(element => {
                    if (element.marker.getIcon().url) {
                        element.marker.setIcon(
                            new google.maps.MarkerImage(
                                element.marker.getIcon().url, //marker's same icon graphic
                                null, //size
                                null, //origin
                                null, //anchor
                                new google.maps.Size(relativePixelSize, relativePixelSize) //changes the scale
                            )
                        );
                    }
                });
            });
            */
        });
    }

    async centerCurrentPosition() {
        this.map.setCenter(this.currentPosition);
    }

    createCrosshairMarker() {
        if (this.latlng) {
            let reticleMarker = new google.maps.Marker({
                position: this.map.getCenter(),
                icon: new google.maps.MarkerImage(
                    'assets/imgs/marker-crosshair.svg',
                    new google.maps.Size(32, 57),
                    new google.maps.Point(0, 0),
                    new google.maps.Point(16, 50)
                ),
                shape: {
                    coords: [32, 32, 32, 32],
                    type: 'rect'
                },
                optimized: false,
                zIndex: 10
            });

            //keep centered
            google.maps.event.addListener(this.map, 'bounds_changed', () => {
                reticleMarker.setPosition(this.map.getCenter());
            });

            //register as visible marker
            this.addMarkerVisible({ meta: null, marker: reticleMarker });

            return reticleMarker;
        }
        else {
            //console.log("latlng is null");
        }
    }

    cleanUp() {
        this.visibleMarkers.forEach(item => {
            item.marker.setMap(null);
        });
        this.markers = [];
        this.visibleMarkers = [];
        this.filter = null;
    }

    addMarkerVisible(item) {
        item.marker.setMap(this.map);
        _.pull(this.markers, item);
        this.visibleMarkers.push(item);
    }

    removeMarkerVisible(item) {
        item.marker.setMap(null);
        _.pull(this.visibleMarkers, item);
        this.markers.push(item);
    }

    createMarker(data) {
        let icon = null;
    
        if (data.origin === "google" || (data.editable == 1 && !data.color)) {
            icon = "assets/imgs/marker-oval-grey.svg";
        }
        else {
            //validate color HEX ex: #fff, #FFFFFF
            var colorRegex = new RegExp("^#(([0-9a-fA-F]{2}){3}|([0-9a-fA-F]){3})$");
            if(data.color && colorRegex.exec(data.color).length > 0){
                var svg = '<?xml version="1.0" encoding="UTF-8"?><svg width="30px" height="54px" viewBox="0 0 30 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><circle fill="#FFBA29" cx="15" cy="42" r="12"></circle><path d="M22.5,15 C22.5,12.9296771 21.7675854,11.1621167 20.3027344,9.69726563 C18.8378833,8.23241455 17.0703229,7.5 15,7.5 C12.9296771,7.5 11.1621167,8.23241455 9.69726562,9.69726563 C8.23241455,11.1621167 7.5,12.9296771 7.5,15 C7.5,17.0703229 8.23241455,18.8378833 9.69726562,20.3027344 C11.1621167,21.7675854 12.9296771,22.5 15,22.5 C17.0703229,22.5 18.8378833,21.7675854 20.3027344,20.3027344 C21.7675854,18.8378833 22.5,17.0703229 22.5,15 L22.5,15 Z M30,15 C30,17.1289169 29.6777376,18.8769463 29.0332031,20.2441406 L18.3691406,42.9199219 C18.0566391,43.5644563 17.5927765,44.0722638 16.9775391,44.4433594 C16.3623016,44.814455 15.7031285,45 15,45 C14.2968715,45 13.6376984,44.814455 13.0224609,44.4433594 C12.4072235,44.0722638 11.9531265,43.5644563 11.6601562,42.9199219 L0.966796875,20.2441406 C0.322262402,18.8769463 0,17.1289169 0,15 C0,10.8593543 1.4648291,7.3242334 4.39453125,4.39453125 C7.3242334,1.4648291 10.8593543,0 15,0 C19.1406457,0 22.6757666,1.4648291 25.6054688,4.39453125 C28.5351709,7.3242334 30,10.8593543 30,15 L30,15 Z" fill="' + data.color + '"></path></g></svg>';
                icon = { 
                    url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
                    scaledSize: new google.maps.Size(30, 54)
                };
            }
            else{
                icon = 'assets/imgs/marker-oval-red.svg';
            }
        }

        let marker = new google.maps.Marker({
            // label: data.name,
            position: new google.maps.LatLng(data.location.lat, data.location.lng),
            icon: icon
        });

        marker.addListener("click", () => {
            this.markerSelected.emit(data);
        });

        let dataMarker = { meta: data, marker: marker };

        this.markers.push(dataMarker);

        if (this.executeFilter(dataMarker)) {
            this.addMarkerVisible(dataMarker);
        }

        return dataMarker;
    }

    async centerMarker(markerId) {
        let tmpSpots = this.visibleMarkers.concat(this.markers);
        tmpSpots.forEach(element => {
            if (element.meta && element.meta.id === markerId) {
                this.map.panTo(
                    new google.maps.LatLng(
                        element.meta.location.lat,
                        element.meta.location.lng
                    )
                );
            }
        });
    }

    deleteMarker(marker) {
        this.markers = _.filter(this.markers, n => {
            if (n.meta && n.meta.id === marker.id) {
                n.marker.setMap(null);
                return false;
            }
            return true;
        });
        this.visibleMarkers = _.filter(this.visibleMarkers, n => {
            if (n.meta && n.meta.id === marker.id) {
                n.marker.setMap(null);
                return false;
            }
            return true;
        });
    }

    static latLng2Point(latLng, map) {
        var topRight = map
            .getProjection()
            .fromLatLngToPoint(map.getBounds().getNorthEast());
        var bottomLeft = map
            .getProjection()
            .fromLatLngToPoint(map.getBounds().getSouthWest());
        var scale = Math.pow(2, map.getZoom());
        var worldPoint = map.getProjection().fromLatLngToPoint(latLng);
        return new google.maps.Point(
            (worldPoint.x - bottomLeft.x) * scale,
            (worldPoint.y - topRight.y) * scale
        );
    }

    static point2LatLng(point, map) {
        var topRight = map
            .getProjection()
            .fromLatLngToPoint(map.getBounds().getNorthEast());
        var bottomLeft = map
            .getProjection()
            .fromLatLngToPoint(map.getBounds().getSouthWest());
        var scale = Math.pow(2, map.getZoom());
        var worldPoint = new google.maps.Point(
            point.x / scale + bottomLeft.x,
            point.y / scale + topRight.y
        );
        return map.getProjection().fromPointToLatLng(worldPoint);
    }
}
